import { mimeTypes } from '@/modules/base/util/constants'

const isMSOfficeDocument = (mimetype) => {
  return [
    mimeTypes.MIMETYPE_PPT,
    mimeTypes.MIMETYPE_PPTX,
    mimeTypes.MIMETYPE_DOC,
    mimeTypes.MIMETYPE_DOCX,
    mimeTypes.MIMETYPE_XLS,
    mimeTypes.MIMETYPE_XLSX].includes(mimetype)
}

export default isMSOfficeDocument
